import { configureStore } from '@reduxjs/toolkit'
import ensReducer from './reducers/EnsReducer'
import filtreCopiesReducer from './reducers/FiltreCopiesReducer'
import llistatReducer from './reducers/LlistatReducer'
import { paginationReducer } from './reducers/PaginationReducer'
import filtreOrgansReducer from './reducers/FiltreOrgansReducer'
import filtrePlantillesReducer from './reducers/FiltrePlantillesReducer'
import { sidebarReducer } from './reducers/SidebarReducer'

const store = configureStore({
  reducer: {
    ens: ensReducer,
    sidebar: sidebarReducer,
    filtreCopies: filtreCopiesReducer,
    filtreOrgans: filtreOrgansReducer,
    filtrePlantilles: filtrePlantillesReducer,
    llistat: llistatReducer,
    pagination: paginationReducer
  }
})

export default store

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
